import {filterArrayUndefined, undefinedIfThrowSync} from '@coolcolduk/util';
import {QueryDocumentSnapshot, QuerySnapshot} from 'firebase/firestore';

/**
 * Convert query snapshot to data array
 * - remove ones that does not pass the mapper
 * @param querySnapshot
 * @param mapper if error, it should throw. this will be caught in this function and removed from the array
 * @returns
 */
export default function mapFirestoreQuerySnapshotToData<T, R>(
  querySnapshot: QuerySnapshot<T>,
  mapper: (d: QueryDocumentSnapshot<T>) => R,
): R[] {
  const rtn = querySnapshot.docs.map((doc) => undefinedIfThrowSync(() => mapper(doc)));
  return filterArrayUndefined(rtn);
}
